import React , {useState} from 'react';
import MessageList from "./message.list.component";
import text from '../../languages/english/translate.json';

export default function AllMessages(props){
    return(
        <section className="border-right pt-3 pb-3">
            <header className="row m-0 mb-2">
                <article className="col-9 ">
                   <h6 className="text-dark bold"> {text.messages.AllMessages} </h6>
                </article>
                <article className="col-3 text-right ">
                   <p style={{fontSize : '12px'}} className="text-grey mb-0">{props.data?.length} {text.messages.unread}</p>
                </article>
            </header>
            <main  style={{height : '72vh' , scrollBehavior : "smooth"  , overflow : "auto"}}>
                {props.data?.map(message=>
                    <MessageList handleMessageClick={props.handleMessageClick} messageDetails={message}/>
                )}
            </main>
        </section>
    )
}